var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Right_arrow",
    "data-name": "Right arrow",
    d: "M870.636-2336.635A8.944,8.944,0,0,1,868-2343a8.943,8.943,0,0,1,2.636-6.364A8.941,8.941,0,0,1,877-2352a8.94,8.94,0,0,1,6.364,2.636A8.94,8.94,0,0,1,886-2343a8.942,8.942,0,0,1-2.636,6.365A8.94,8.94,0,0,1,877-2334,8.94,8.94,0,0,1,870.636-2336.635ZM869.349-2343a7.661,7.661,0,0,0,7.652,7.652,7.661,7.661,0,0,0,7.652-7.652,7.661,7.661,0,0,0-7.652-7.652A7.661,7.661,0,0,0,869.349-2343Zm7.637,3.543a.674.674,0,0,1,0-.953l1.625-1.625h-4.849a.674.674,0,0,1-.674-.674.674.674,0,0,1,.674-.674h4.849l-1.625-1.625a.676.676,0,0,1,0-.954.676.676,0,0,1,.953,0l2.775,2.776a.671.671,0,0,1,.144.212l0,0,0,.009,0,.009,0,0,0,.013h0a.67.67,0,0,1,.038.223.673.673,0,0,1-.212.491l-2.761,2.761a.672.672,0,0,1-.477.2A.672.672,0,0,1,876.986-2339.457Z",
    transform: "translate(-868.001 2352)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/Right arrow.2ec0697c4a39809a5e4dea5b81a6f82d.svg";
export { ForwardRef as ReactComponent };